import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || 'https://sbmcpzmgdxznnckfnhnr.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNibWNwem1nZHh6bm5ja2ZuaG5yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg0ODI2MzMsImV4cCI6MjA2NDA1ODYzM30.q1V0k_JuFuYfx504_DhriuHD2n5ZT6g2ZyYUpykshEQ';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
